import * as React from 'react';
import type { SiteWithSpaceName, SpaceWithSiteCount } from '@klareospace/pharos-lib-types';
import { useTranslation } from 'react-i18next';
import { SiteResult } from './site-result';
import { SpaceResult } from './space-result';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface ResultsListProps {
  onBrowseSpace: (spaceId: string, spaceName: string) => void;
  onClose: () => void;
  sites: SiteWithSpaceName[];
  spaces: SpaceWithSiteCount[];
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ResultsList({ onBrowseSpace, onClose, sites, spaces }: ResultsListProps): React.JSX.Element {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col pb-2">
      {spaces.length > 0 && (
        <div>
          <div className="px-3 py-1.5">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
              {t('mainSelector.spaces')}
            </span>
          </div>
          {spaces.map((space) => (
            <SpaceResult key={space.id} onBrowseSpace={onBrowseSpace} onClose={onClose} space={space} />
          ))}
        </div>
      )}
      {sites.length > 0 && (
        <div>
          <div className="px-3 py-1.5">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
              {t('mainSelector.sites')}
            </span>
          </div>
          {sites.map((site) => (
            <SiteResult key={site.id} onClose={onClose} site={site} />
          ))}
        </div>
      )}
    </div>
  );
}
